import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#09090b] text-white py-16 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo y descripción */}
          <div className="text-center md:text-left">
            <h3 className="font-barlow text-3xl font-black uppercase mb-2">
              BOOTY<span className="text-pink-500">&</span>LEGS
            </h3>
            <p className="text-zinc-500 text-sm max-w-md">
              Transforma tu cuerpo, transforma tu vida. Academia de entrenamiento especializada en glúteos y piernas.
            </p>
          </div>

          {/* Links rápidos */}
          <div className="flex gap-6">
            <Link to="/programs" className="text-zinc-400 hover:text-pink-500 transition-colors text-sm">Programas</Link>
            <Link to="/coaching" className="text-zinc-400 hover:text-pink-500 transition-colors text-sm">Coaching 1-1</Link>
            <Link to="/login" className="text-zinc-400 hover:text-pink-500 transition-colors text-sm">Iniciar Sesión</Link>
          </div>

          {/* Redes sociales */}
          <div className="flex gap-3">
            <a 
              href="https://instagram.com/deisyfit" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center hover:bg-pink-500 transition-colors"
              data-testid="instagram-deisyfit"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a 
              href="https://instagram.com/karenmarinob" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center hover:bg-pink-500 transition-colors"
              data-testid="instagram-karenmarinob"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a 
              href="mailto:bootyandlegsacademy@gmail.com" 
              className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center hover:bg-pink-500 transition-colors"
              data-testid="email-contact"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8 text-center">
          <p className="text-zinc-600 text-sm">
            © {new Date().getFullYear()} Booty & Legs Academy. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
